// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section[data-v-0afc0f16]{background-color:#f3efea;border-radius:1.5rem}.heading-2[data-v-0afc0f16]{color:#263a22;margin:0;text-align:center}.line-2[data-v-0afc0f16]{align-items:center;display:flex;justify-content:center}@media screen and (min-width:40.063em){.section.section_cta[data-v-0afc0f16]{padding:2rem 5rem}}@media screen and (min-width:90.063em){.cta[data-v-0afc0f16]{align-items:center;display:flex;justify-content:center}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
